var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "generate-lender-notes-modal", "modal-dialog-size": "xl" },
    on: {
      hide: function ($event) {
        return _vm.$emit("hide", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "options-grid" }, [
              _c("div", { staticClass: "options-left" }, [
                _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                  _c("span", { staticStyle: { display: "inline-block" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("direct-to-lender.lenderSubmit.optionalElements")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pretty p-switch p-fill ml-4" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeAll,
                          expression: "includeAll",
                        },
                      ],
                      attrs: { id: "include-all", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeAll)
                          ? _vm._i(_vm.includeAll, null) > -1
                          : _vm.includeAll,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeAll,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.includeAll = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeAll = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeAll = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "state" }, [
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 ml-1 clickable",
                          attrs: { for: "include-all" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("direct-to-lender.lenderSubmit.includeAll")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { on: { change: _vm.handleElementChange } }, [
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeDownPayment,
                          expression: "includeDownPayment",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeDownPayment)
                          ? _vm._i(_vm.includeDownPayment, null) > -1
                          : _vm.includeDownPayment,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeDownPayment,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.includeDownPayment = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeDownPayment = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeDownPayment = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("direct-to-lender.lenderSubmit.downPayment")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeRatios,
                          expression: "includeRatios",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeRatios)
                          ? _vm._i(_vm.includeRatios, null) > -1
                          : _vm.includeRatios,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeRatios,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.includeRatios = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeRatios = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeRatios = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.ratios"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeCreditScores,
                          expression: "includeCreditScores",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeCreditScores)
                          ? _vm._i(_vm.includeCreditScores, null) > -1
                          : _vm.includeCreditScores,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeCreditScores,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.includeCreditScores = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeCreditScores = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeCreditScores = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("direct-to-lender.lenderSubmit.creditScores")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeOtherPropertiesOwned,
                          expression: "includeOtherPropertiesOwned",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeOtherPropertiesOwned)
                          ? _vm._i(_vm.includeOtherPropertiesOwned, null) > -1
                          : _vm.includeOtherPropertiesOwned,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeOtherPropertiesOwned,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.includeOtherPropertiesOwned = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeOtherPropertiesOwned = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeOtherPropertiesOwned = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "direct-to-lender.lenderSubmit.otherProperties"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { on: { change: _vm.handleElementChange } }, [
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeAssets,
                          expression: "includeAssets",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeAssets)
                          ? _vm._i(_vm.includeAssets, null) > -1
                          : _vm.includeAssets,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeAssets,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.includeAssets = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeAssets = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeAssets = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.assets"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeLiabilities,
                          expression: "includeLiabilities",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeLiabilities)
                          ? _vm._i(_vm.includeLiabilities, null) > -1
                          : _vm.includeLiabilities,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeLiabilities,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.includeLiabilities = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeLiabilities = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeLiabilities = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("direct-to-lender.lenderSubmit.liabilities")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeReqRateDetails,
                          expression: "includeReqRateDetails",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.includeReqRateDetails)
                          ? _vm._i(_vm.includeReqRateDetails, null) > -1
                          : _vm.includeReqRateDetails,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.includeReqRateDetails,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.includeReqRateDetails = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeReqRateDetails = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeReqRateDetails = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("direct-to-lender.lenderSubmit.reqRateDetails")
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "options-right" }, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticStyle: { display: "block", "margin-bottom": "8px" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.language"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.language,
                          expression: "language",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "language",
                        value: "en-CA",
                      },
                      domProps: { checked: _vm._q(_vm.language, "en-CA") },
                      on: {
                        change: function ($event) {
                          _vm.language = "en-CA"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.english"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.language,
                          expression: "language",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "language",
                        value: "fr-CA",
                      },
                      domProps: { checked: _vm._q(_vm.language, "fr-CA") },
                      on: {
                        change: function ($event) {
                          _vm.language = "fr-CA"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.french"))
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticStyle: { display: "block", "margin-bottom": "8px" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.format"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.format,
                          expression: "format",
                        },
                      ],
                      attrs: { type: "radio", name: "format", value: "list" },
                      domProps: { checked: _vm._q(_vm.format, "list") },
                      on: {
                        change: function ($event) {
                          _vm.format = "list"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("direct-to-lender.lenderSubmit.list"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "pill-select-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.format,
                          expression: "format",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "format",
                        value: "conversational",
                      },
                      domProps: {
                        checked: _vm._q(_vm.format, "conversational"),
                      },
                      on: {
                        change: function ($event) {
                          _vm.format = "conversational"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pill-select-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("direct-to-lender.lenderSubmit.conversational")
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row-reverse",
                },
              },
              [
                _c("simple-button", {
                  attrs: {
                    text: _vm.$t("direct-to-lender.lenderSubmit.generateDraft"),
                    loading:
                      _vm.waitingForGeneratedLenderNote ||
                      _vm.loadingSaveSettings,
                  },
                  on: { click: _vm.handleGenerateNote },
                }),
                _vm._v(" "),
                _c("simple-button", {
                  staticClass: "mr-4 ld-ring-primary",
                  attrs: {
                    type: "white",
                    text: _vm.$t("direct-to-lender.lenderSubmit.saveSettings"),
                    loading: _vm.loadingSaveSettings,
                  },
                  on: { click: _vm.handleSaveSettings },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h5", [
              _vm._v(_vm._s(_vm.$t("direct-to-lender.lenderSubmit.results"))),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.generatedNote,
                  expression: "generatedNote",
                },
              ],
              staticStyle: {
                width: "100%",
                height: "300px",
                "overflow-y": "scroll",
                resize: "none",
              },
              domProps: { value: _vm.generatedNote },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.generatedNote = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  background: "gainsboro",
                  "border-radius": "4px",
                  padding: "10px",
                },
              },
              [
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.lenderSubmit.AIGeneratedContentDisclaimer"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              attrs: { text: _vm.$t("direct-to-lender.lenderSubmit.save") },
              on: { click: _vm.handleSaveGeneratedNote },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }